export default "https://cdn-static.gokick.com/assets/ec0505d9ec69830080e0139f10eb42000fec6561/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";